module.exports = __webpack_public_path__ + "media/images/payments/ukash-d0a7072bf2f0de910204f3dea476df08.svg";